module.exports = __webpack_public_path__ + "static/media/loading2.f632a596.gif";